const COMPONENT_NAME = "SelectorRadioButton";
const INVALID_PROPS_ERROR = `${COMPONENT_NAME}-error: invalid props`;
const MISSING_HELP_LINK_WARNING = `${COMPONENT_NAME}-warning: when 'helpLinkTex' and 'helpLinkUrl' must be provided together`;
const MISSING_ARIA_LABEL_PREFIX_WARNING = `${COMPONENT_NAME}-warning: 'ariaLabelErrorPrefix' must be provided when 'errorText' is provided, the component may not meet accessibility standards`;
export {
  COMPONENT_NAME,
  INVALID_PROPS_ERROR,
  MISSING_ARIA_LABEL_PREFIX_WARNING,
  MISSING_HELP_LINK_WARNING
};
